// npm start uses relative URLs and the localhost:8080 proxy in package.json.
// npm run build uses the shop API unless an explicit build-time override is set.
const configuredApiUrl = process.env.REACT_APP_API_BASE_URL?.trim();
const defaultApiUrl = process.env.NODE_ENV === 'development' ? '' : 'https://wargame-shop.com.ua';

export const API_BASE_URL = (configuredApiUrl || defaultApiUrl).replace(/\/+$/, '');
